module.exports = __webpack_public_path__ + "img/message_board_icon_pc.ec893f31.svg";